import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const newsletterAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: true, max: 80 },
  { name: 'subheadline', type: 'string', required: false, max: 200 },
  { name: 'placeholder', type: 'string', required: false, max: 40 },
  { name: 'submitLabel', type: 'string', required: true, max: 24 },
  { name: 'finePrint', type: 'string', required: false, max: 120 },
];

export const newsletterUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'text', label: 'Headline', required: true, max: 80 },
  { name: 'subheadline', type: 'textarea', label: 'Subheadline', max: 200 },
  { name: 'placeholder', type: 'text', label: 'Email placeholder', max: 40 },
  { name: 'submitLabel', type: 'text', label: 'Submit label', required: true, max: 24 },
  { name: 'finePrint', type: 'textarea', label: 'Fine print', max: 120 },
];

export const newsletterZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().min(1).max(80),
  subheadline: z.string().max(200).optional().nullable(),
  placeholder: z.string().max(40).optional().nullable(),
  submitLabel: z.string().min(1).max(24),
  finePrint: z.string().max(120).optional().nullable(),
});

export type NewsletterContent = z.infer<typeof newsletterZodSchema>;

export const newsletterSample: NewsletterContent = {
  eyebrow: 'Stay in the loop',
  headline: 'Updates from the workshop.',
  subheadline:
    'A monthly note on what we are building, customer stories, and the occasional behind-the-scenes.',
  placeholder: 'you@studio.com',
  submitLabel: 'Subscribe',
  finePrint: 'No spam. Unsubscribe with one click.',
};
